import biconomyLogo from 'assets/images/cex/biconomyLogo.svg';
import biconomyWordMark from 'assets/images/cex/biconomyWordMark.svg';
import binaceLogo from 'assets/images/cex/binanceLogo.svg';
import binaceLogoWordMark from 'assets/images/cex/binanceLogoWordMark.svg';
import bingxLogo from 'assets/images/cex/bingxLogo.png';
import bingxLogoWordMark from 'assets/images/cex/bingxLogoWordMark.png';
import bitfinexLogo from 'assets/images/cex/bitfinexLogo.svg';
import bitgetLogo from 'assets/images/cex/bitgetLogo.svg';
import bitgetLogoWordMark from 'assets/images/cex/bitgetLogoWordMark.svg';
import bithumbLogo from 'assets/images/cex/bithumbLogo.svg';
import bitmartLogo from 'assets/images/cex/bitmartLogo.png';
import bitmartLogoWordMark from 'assets/images/cex/bitmartLogoWordMark.png';
import bitstampLogo from 'assets/images/cex/bitstampLogo.svg';
import bitvavoLogo from 'assets/images/cex/bitvavoLogo.svg';
import bullishLogo from 'assets/images/cex/bullishLogo.svg';
import bybitLogo from 'assets/images/cex/bybitLogo.png';
import bybitLogoWordMark from 'assets/images/cex/bybitLogoWordMark.svg';
import coinbaseLogo from 'assets/images/cex/coinbaseLogo.png';
import coinstoreLogoWordMark from 'assets/images/cex/coinstoreLogoWordMark.png';
import coinwLogo from 'assets/images/cex/coinwLogo.svg';
import coinwWordMark from 'assets/images/cex/coinwWordMark.svg';
import cryptoComLogo from 'assets/images/cex/cryptoComLogo.svg';
import dextradeLogo from 'assets/images/cex/dextradeLogo.svg';
import digifinexLogo from 'assets/images/cex/digifinexLogo.svg';
import gateIoLogo from 'assets/images/cex/gateIoLogo.svg';
import gateIoLogoWordMark from 'assets/images/cex/gateIoLogoWordMark.svg';
import geminiLogo from 'assets/images/cex/geminiLogo.png';
import hashkeyLogo from 'assets/images/cex/hashkeyLogo.png';
import hotcoinLogo from 'assets/images/cex/hotcoinLogo.png';
import hotcoinWordMark from 'assets/images/cex/hotcoinWordMark.png';
import huobiLogo from 'assets/images/cex/huobiLogo.svg';
import huobiLogoWordMark from 'assets/images/cex/huobiLogoWordMark.svg';
import indodaxLogo from 'assets/images/cex/indodaxLogo.jpg';
import indodaxLogoWordMark from 'assets/images/cex/indodaxLogoWordMark.png';
import krakenLogo from 'assets/images/cex/krakenLogo.png';
import krakenWordMark from 'assets/images/cex/krakenWordMark.svg';
import kuCoinLogo from 'assets/images/cex/kuCoinLogo.svg';
import kuCoinWordMarkIcon from 'assets/images/cex/kuCoinWordMark.svg';
import lbankLogo from 'assets/images/cex/lbankLogo.png';
import lbankLogoWordMark from 'assets/images/cex/lbankLogoWordMark.png';
import mexcLogo from 'assets/images/cex/mexcLogo.svg';
import mexcLogoWordMark from 'assets/images/cex/mexcWordMark.svg';
import okxLogo from 'assets/images/cex/okxLogo.png';
import okxLogoWordMark from 'assets/images/cex/okxLogoWordMark.svg';
import toobitLogo from 'assets/images/cex/toobitLogo.svg';
import upbitLogo from 'assets/images/cex/upbitLogo.svg';
import weexLogo from 'assets/images/cex/weexLogo.svg';
import weexWordMark from 'assets/images/cex/weexWordMark.svg';
import whitebitLogo from 'assets/images/cex/whitebitLogo.png';
import whitebitLogoWordMark from 'assets/images/cex/whitebitLogoWordMark.png';
import xtLogo from 'assets/images/cex/xtLogo.svg';
import xtLogoWordMark from 'assets/images/cex/xtLogoWordMark.svg';

export enum ECexName {
  gate = 'gate',
  kucoin = 'kucoin',
  mexc = 'mexc',
  binance = 'binance',
  bitget = 'bitget',
  okx = 'okx',
  bybit = 'bybit',
  bingx = 'bingx',
  bithumb = 'bithumb',
  bitmart = 'bitmart',
  bitstamp = 'bitstamp',
  bitvavo = 'bitvavo',
  toobit = 'toobit',
  hashkey = 'hashkey',
  bullish = 'bullish',
  gemini = 'gemini',
  bitfinex = 'bitfinex',
  xt = 'xt',
  lbank = 'lbank',
  htx = 'htx',
  whitebit = 'whitebit',
  coinbase = 'coinbase',
  cryptocom = 'cryptocom',
  upbit = 'upbit',
  coinstore = 'coinstore',
  indodax = 'indodax',
  hotcoin = 'hotcoin',
  kraken = 'kraken',
  weex = 'weex',
  biconomy = 'biconomy',
  coinw = 'coinw',
  dextrade = 'dextrade',
  digifinex = 'digifinex',
}

interface IConfig {
  cexLink: (base: string, quote: string) => string;
  icon: string;
  iconText: string;
  withPassphrase: boolean;
  apiKeyLabel?: string;
  secretLabel?: string;
  multilineSecret?: boolean;
}

export const cexConfigs: Record<ECexName, IConfig> = {
  [ECexName.binance]: {
    cexLink: (base: string, quote: string) => `https://www.binance.com/trade/${base}_${quote}`,
    icon: binaceLogo,
    iconText: binaceLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.gate]: {
    cexLink: (base: string, quote: string) => `https://www.gate.io/trade/${base}_${quote}`,
    icon: gateIoLogo,
    iconText: gateIoLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.kucoin]: {
    cexLink: (base: string, quote: string) => `https://www.kucoin.com/trade/${base}-${quote}`,
    icon: kuCoinLogo,
    iconText: kuCoinWordMarkIcon,
    withPassphrase: true,
  },
  [ECexName.mexc]: {
    cexLink: (base: string, quote: string) => `https://mexc.com/exchange/${base}_${quote}`,
    icon: mexcLogo,
    iconText: mexcLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.okx]: {
    cexLink: (base: string, quote: string) => `https://www.okx.com/trade-spot/${base}-${quote}`,
    icon: okxLogo,
    iconText: okxLogoWordMark,
    withPassphrase: true,
  },
  [ECexName.bybit]: {
    cexLink: (base: string, quote: string) => `https://www.bybit.com/trade/spot/${base}/${quote}`,
    icon: bybitLogo,
    iconText: bybitLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.htx]: {
    cexLink: (base: string, quote: string) =>
      `https://www.htx.com/trade/${base.toLowerCase()}_${quote.toLowerCase()}`,
    icon: huobiLogo,
    iconText: huobiLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.bitget]: {
    cexLink: (base: string, quote: string) => `https://www.bitget.com/spot/${base}${quote}`,
    icon: bitgetLogo,
    iconText: bitgetLogoWordMark,
    withPassphrase: true,
  },
  [ECexName.bingx]: {
    cexLink: (base: string, quote: string) =>
      `https://bingx.com/uk-ua/spot/${base.toUpperCase()}${quote.toUpperCase()}`,
    icon: bingxLogo,
    iconText: bingxLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.bithumb]: {
    cexLink: (base: string, quote: string) =>
      `https://www.bithumb.com/react/trade/order/${base.toUpperCase()}-${quote.toUpperCase()}`,
    icon: bithumbLogo,
    iconText: bithumbLogo,
    withPassphrase: false,
  },
  [ECexName.whitebit]: {
    cexLink: (base: string, quote: string) =>
      `https://whitebit.com/trade/${base.toUpperCase()}-${quote.toUpperCase()}`,
    icon: whitebitLogo,
    iconText: whitebitLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.bitmart]: {
    cexLink: (base: string, quote: string) =>
      `https://www.bitmart.com/trade?symbol=${base.toUpperCase()}_${quote.toUpperCase()}`,
    icon: bitmartLogo,
    iconText: bitmartLogoWordMark,
    withPassphrase: true,
  },
  [ECexName.bitstamp]: {
    cexLink: (base: string, quote: string) =>
      `https://www.bitstamp.net/markets/${base.toLowerCase()}/${quote.toLowerCase()}/`,
    icon: bitstampLogo,
    iconText: bitstampLogo,
    withPassphrase: false,
  },
  [ECexName.bitvavo]: {
    cexLink: (base: string, quote: string) =>
      `https://account.bitvavo.com/markets/${base.toUpperCase()}-${quote.toUpperCase()}`,
    icon: bitvavoLogo,
    iconText: bitvavoLogo,
    withPassphrase: false,
  },
  [ECexName.toobit]: {
    cexLink: (base: string, quote: string) =>
      `https://www.toobit.com/en-US/spot/${base.toUpperCase()}_${quote.toUpperCase()}`,
    icon: toobitLogo,
    iconText: toobitLogo,
    withPassphrase: false,
  },
  [ECexName.hashkey]: {
    cexLink: (base: string, quote: string) =>
      `https://global.hashkey.com/spot/${base.toUpperCase()}_${quote.toUpperCase()}`,
    icon: hashkeyLogo,
    iconText: hashkeyLogo,
    withPassphrase: false,
  },
  [ECexName.bullish]: {
    cexLink: (base: string, quote: string) =>
      `https://exchange.bullish.com/trade/${base.toUpperCase()}${quote.toUpperCase()}`,
    icon: bullishLogo,
    iconText: bullishLogo,
    withPassphrase: false,
  },
  [ECexName.gemini]: {
    cexLink: () => 'https://www.gemini.com/activetrader',
    icon: geminiLogo,
    iconText: geminiLogo,
    withPassphrase: false,
  },
  [ECexName.bitfinex]: {
    cexLink: (base: string, quote: string) =>
      `https://trading.bitfinex.com/t/${base.toUpperCase()}:${quote.toUpperCase()}`,
    icon: bitfinexLogo,
    iconText: bitfinexLogo,
    withPassphrase: false,
  },
  [ECexName.lbank]: {
    cexLink: (base: string, quote: string) =>
      `https://www.lbank.com/trade/${base.toLowerCase()}_${quote.toLowerCase()}`,
    icon: lbankLogo,
    iconText: lbankLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.coinstore]: {
    cexLink: (base: string, quote: string) => `https://www.coinstore.com/spot/${base}${quote}`,
    icon: coinbaseLogo,
    iconText: coinstoreLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.coinbase]: {
    cexLink: (base: string, quote: string) =>
      `https://www.coinbase.com/advanced-trade/spot/${base.toUpperCase()}-${quote.toUpperCase()}`,
    icon: coinbaseLogo,
    iconText: coinbaseLogo,
    withPassphrase: false,
    apiKeyLabel: 'CDP key name',
    secretLabel: 'Private key (PEM)',
    multilineSecret: true,
  },
  [ECexName.cryptocom]: {
    cexLink: (base: string, quote: string) =>
      `https://crypto.com/exchange/trade/spot/${base.toUpperCase()}_${quote.toUpperCase()}`,
    icon: cryptoComLogo,
    iconText: cryptoComLogo,
    withPassphrase: false,
  },
  [ECexName.upbit]: {
    cexLink: (base: string, quote: string) =>
      `https://upbit.com/exchange?code=CRIX.UPBIT.${quote.toUpperCase()}-${base.toUpperCase()}`,
    icon: upbitLogo,
    iconText: upbitLogo,
    withPassphrase: false,
  },
  [ECexName.xt]: {
    cexLink: (base: string, quote: string) =>
      `https://www.xt.com/trade/${base.toLowerCase()}_${quote.toLowerCase()}`,
    icon: xtLogo,
    iconText: xtLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.indodax]: {
    cexLink: (base: string, quote: string) =>
      `https://indodax.com/market/${base.toUpperCase()}${quote.toUpperCase()}`,
    icon: indodaxLogo,
    iconText: indodaxLogoWordMark,
    withPassphrase: false,
  },
  [ECexName.hotcoin]: {
    cexLink: (base: string, quote: string) =>
      `https://www.hotcoin.com/en_US/trade/exchange/?tradeCode=${base.toLowerCase()}_${quote.toLowerCase()}`,
    icon: hotcoinLogo,
    iconText: hotcoinWordMark,
    withPassphrase: false,
  },
  [ECexName.kraken]: {
    cexLink: (base: string, quote: string) =>
      `https://pro.kraken.com/app/trade/${base.toLowerCase()}-${quote.toLowerCase()}`,
    icon: krakenLogo,
    iconText: krakenWordMark,
    withPassphrase: false,
  },
  [ECexName.weex]: {
    cexLink: (base: string, quote: string) => `https://www.weex.com/spot/${base}${quote}`,
    icon: weexLogo,
    iconText: weexWordMark,
    withPassphrase: true,
  },
  [ECexName.biconomy]: {
    cexLink: (base: string, quote: string) => `https://www.biconomy.com/exchange/${base}_${quote}`,
    icon: biconomyLogo,
    iconText: biconomyWordMark,
    withPassphrase: false,
  },
  [ECexName.coinw]: {
    cexLink: (base: string, quote: string) =>
      `https://www.coinw.com/spot/${base.toUpperCase()}_${quote.toUpperCase()}`,
    icon: coinwLogo,
    iconText: coinwWordMark,
    withPassphrase: false,
  },
  [ECexName.dextrade]: {
    cexLink: (base: string, quote: string) =>
      `https://dex-trade.com/spot/trading/${base.toUpperCase()}${quote.toUpperCase()}?interface=classic`,
    icon: dextradeLogo,
    iconText: dextradeLogo,
    withPassphrase: false,
  },
  [ECexName.digifinex]: {
    cexLink: (base: string, quote: string) =>
      `https://www.digifinex.com/en-ww/trade/${base.toLowerCase()}_${quote.toLowerCase()}`,
    icon: digifinexLogo,
    iconText: digifinexLogo,
    withPassphrase: false,
  },
};

export const hasCexPassphrase = (cex?: ECexName): boolean =>
  !!cex && cexConfigs[cex]?.withPassphrase === true;
